import type { SpaceDirection } from '../types/layout-operations'
import { SpaceBetweenIcon } from './space-between-icon'
import { TooltipIconButton } from './tooltip-icon-button'

const SPACE_BETWEEN_TOOLS = [
  { direction: 'horizontal', label: 'Horizontal Space Between' },
  { direction: 'vertical', label: 'Vertical Space Between' },
] as const

interface SpaceBetweenButtonsProps {
  disabled: boolean
  onDirectionClick: (direction: SpaceDirection) => void
}

export function SpaceBetweenButtons({ disabled, onDirectionClick }: SpaceBetweenButtonsProps) {
  return (
    <div className="space-y-2">
      <label className="text-sm font-medium text-foreground leading-none">Space Between</label>
      <div className="flex gap-2 mt-2">
        {SPACE_BETWEEN_TOOLS.map(({ direction, label }) => (
          <TooltipIconButton
            key={direction}
            tooltip={label}
            aria-label={label}
            disabled={disabled}
            onClick={() => onDirectionClick(direction)}
            className="h-9 w-9 text-foreground"
          >
            <SpaceBetweenIcon direction={direction} />
          </TooltipIconButton>
        ))}
      </div>
    </div>
  )
}
